import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import PropTypes from 'prop-types';

import filter from 'lodash/fp/filter';

import { styled } from '@prose-ui/legacy';

import Spacer from 'Components/Spacer';

import { productsSlugs } from 'constants/products';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import LoadingScene from 'Scenes/LoadingScene';

import { customHaircare as customHaircareData } from 'assets/content/home';

import useMedia from 'utils/useMedia';
import useResponsiveVariant from 'utils/useResponsiveVariant';

import { useFetchProductsList } from 'dux/products/hooks';

import HairCareHero from './CustomHaircare/HairCareHero';
import DesktopCustomSlider from './CustomSlider/DesktopSlider';
import MobileCustomSlider from './CustomSlider/MobileSlider';
import ProductCard from './ProductCard';

const toFilterSlugs = [
  productsSlugs.STYLING_GEL,
  productsSlugs.SHAMPOO,
  productsSlugs.CONDITIONER,
  productsSlugs.HAIR_MASK,
];
const filterAndOrderProducts = (products, slugsToFilter) =>
  filter(product => slugsToFilter.includes(product.slug), products).sort(
    (a, b) => slugsToFilter.indexOf(a.slug) - toFilterSlugs.indexOf(b.slug)
  );

const SectionContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  background: ${props => props.theme.palette.common.beige.light};
`;
const CustomHaircare = ({ heroContent }) => {
  const { isLoaded, haircareProducts } = useFetchProductsList();
  const { isDesktop, isMobile } = useResponsiveVariant();
  const isTabletMin = useMedia(`(min-width: 819px)`);
  const isTabletMax = useMedia(`(max-width: 1040px)`);

  const isTabletMatch = isTabletMin && isTabletMax;
  const filteredProduct = filterAndOrderProducts(haircareProducts, toFilterSlugs);

  if (!isLoaded) {
    return <LoadingScene />;
  }
  const cards = filteredProduct.map(product => {
    return (
      <ProductCard
        key={product.label}
        dataClick={`${product.slug}-card`}
        dataFrom="haircare-grid"
        margin={20}
        product={product}
      />
    );
  });
  return (
    <SectionContainer>
      <HairCareHero heroContent={heroContent} />
      <Spacer size={isDesktop ? 76 : 0} />
      {isMobile || isTabletMatch ? (
        <MobileCustomSlider fetchedProducts={filteredProduct} />
      ) : (
        <DesktopCustomSlider cards={cards} />
      )}
    </SectionContainer>
  );
};

CustomHaircare.defaultProps = {
  heroContent: customHaircareData,
};

CustomHaircare.propTypes = {
  heroContent: PropTypes.shape({
    imageAlt: PropTypes.string,
    imageMobile: srcOrNextImageProp,
    imageDesktop: srcOrNextImageProp,
    title: PropTypes.string,
    primaryTitle: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.shape({ label: PropTypes.string, path: PropTypes.string }),
  }),
};

export default CustomHaircare;
